import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import RadioEpisodes from '@aron/audio/radio-episodes/RadioEpisodes';

export function init() {
  const containers = Array.from(
    document.querySelectorAll('.js-radio-episodes'),
  ) as HTMLElement[];

  containers.forEach((container) => {
    const radioShowId = container.dataset.radioShowId ?? '';
    const nextRadioEpisodes = JSON.parse(
      container.dataset.nextRadioEpisodes ?? '',
    );
    const queryClient = new QueryClient();

    ReactDOM.createRoot(container).render(
      <React.StrictMode>
        <QueryClientProvider client={queryClient}>
          <RadioEpisodes
            radioShowId={radioShowId}
            nextRadioEpisodes={nextRadioEpisodes}
          />
        </QueryClientProvider>
      </React.StrictMode>,
    );
  });
}
